<template>
  <div>
    <select-shop :loadingButton="loadingButton" v-on:getData=""></select-shop>
    <!-- <div v-if="isPermission"> -->
    <CCard class="shadow-sm">
      <CCardBody>
        <CAlert :id="alertMessageID" :color="color" v-if="alertTitle" :show="Number(3)">
            {{ alertTitle }}
          </CAlert>
        <CRow>
          <CCol sm="12" lg="12">
            <div class="row">
              <div class="col-md-10 col-sm-9 col-8">
                <h2 class="text-dark font-weight-normal">
                  {{ $t("supplier") }}
                </h2>
                <h5 class="text-dark font-weight-normal">
                  {{ $t("supplierCount") }} ({{ countMember }})
                </h5>
              </div>

              <div class="col-md-2 col-4 text-right text-success">
                <CButton @click="$router.push('/supplier/create')" block color="dark" >
                  <i class="fi fi-rr-user"></i>
                  {{ $t("createSupplier") }}
                </CButton>

                <CButton
                  class="mt-2"
                  block
                  color="info"
                  v-if="isExport && loadingButton === true"
                  @click=""
                >
                  <img
                    src="/img/file-excel.png"
                    alt="Excel Icon"
                    style="
                      width: 16px;
                      height: 16px;
                      margin-right: 8px;
                      vertical-align: middle;
                      position: relative;
                      top: -2px;
                    "
                  />{{ $t("export") }}
                </CButton>
                <CButton
                  class="mt-2"
                  block
                  color="info"
                  v-if="isExport && loadingButton === false"
                  disabled
                >
                  <img
                    src="/img/file-excel.png"
                    alt="Excel Icon"
                    style="
                      width: 16px;
                      height: 16px;
                      margin-right: 8px;
                      vertical-align: middle;
                      position: relative;
                      top: -2px;
                    "
                  />{{ $t("export") }}
                </CButton>
              </div>
            </div>
            <hr />
            <CRow>
              <CCol sm="10">
                <CInput
                  :placeholder="$t('searchMember')"
                  v-model="search"
                  @input="getSupplierReport()"
                />
              </CCol>
              <CCol sm="2" v-if="loadingButton === true">
                <CButton v-on:click="getSupplierReport()" block color="success">
                  {{ $t("search") }}
                </CButton>
              </CCol>
              <CCol sm="2" v-else-if="loadingButton === false">
                <CButton block color="success" disabled>
                  <CSpinner color="white" size="sm" /> {{ $t("loading") }}
                </CButton>
              </CCol>
            </CRow>
            <div style="overflow-x: auto">
              <CDataTable
                :items="items"
                :fields="fields"
                :loading="loading"
                border
                style="white-space: nowrap; cursor:pointer"
                @row-clicked="toggleDetails"
              >
                <template #address="{ item }">
                  <td class="py-2 text-dark address-cell">
                    {{ item.address }}
                  </td>
                </template>
                <template #action="{ item, index }">
                  <td class="text-center">
                    <CRow>
                      <CCol>
                        <img
                          :id="'supplierEditIcon' + index"
                          @click="$router.push('/supplier/detail/' + item.objectId)"
                          src="/img/file-edit.png"
                          style="width: 14px; height: 14px; cursor: pointer"
                        />
                      </CCol>
                      <!-- <CCol v-if="item.id !== '0' && isEdit == true">
                        <img
                          :id="'supplierDeleteIcon' + index"
                          @click="deleteSupplier(item.objectId)"
                          src="/img/trash.png"
                          style="width: 14px; height: 14px; cursor: pointer"
                        />
                      </CCol> -->
                    </CRow>
                  </td>
                </template>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8">
                      {{ $t("noItem") }}
                    </h4>
                  </div>
                </template>
              </CDataTable>
            </div>
          </CCol>
        </CRow>
        <pagination :meta_data="meta_data" v-on:next="getSupplierReport"> </pagination>
      </CCardBody>
    </CCard>
    <!-- </div>
    <div v-else>
      <access-data></access-data>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import local from "@/services/local";
import moment from "moment";
import util from "@/util/util";
import Pagination from "@/containers/Pagination";
import permis from "@/util/permission";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      data: [],
      search: "",
      loadingButton: true,
      loading: false,
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      countMember: 0,
      alertTitle: "",
      deleteModal: false,
      color: '',
      alertMessageID: '',
      supplierModal: false,
      nameModal: "",
    };
  },
  computed: {
    ...mapGetters(["shops", "date", "users", "permain"]),
    uid() {
      return `${localStorage.getItem("shopsUid")}`;
    },
    isPermission() {
      return permis.findPermissionRead("member", this.$route.path);
    },
    isEdit() {
      return permis.findPermissionEdit("member", this.$route.path);
    },
    isExport() {
      return permis.findPermissionExport("member", this.$route.path);
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    startDate() {
      return moment(String(this.date.start)).format("DD MMMM YYYY");
    },
    endDate() {
      return moment(String(this.date.end)).format("DD MMMM YYYY");
    },
    fields() {
      return [
        {
          key: "name",
          label: this.$i18n.t("supplierName"),
          _style: "width:20%",
          _classes: "text-dark font-weight-normal",
        },
        {
          key: "supplierCode",
          _style: "width:10%",
          label: this.$i18n.t("supplierCode"),
          _classes: "text-dark font-weight-normal",
        },
        {
          key: "address",
          label: this.$i18n.t("address"),
          _style: "width:20%",
          _classes: "text-dark font-weight-normal",
        },
        {
          key: "taxId",
          label: this.$i18n.t("taxID"),
          _style: "width:10%",
          _classes: "text-dark font-weight-normal",
        },
        {
          key: "creditTerm",
          _style: "width:10%",
          label: this.$i18n.t("creditTerm"),
          _classes: "text-dark font-weight-normal",
        },
        {
          key: "vatOption",
          _style: "width:10%",
          label: this.$i18n.t("vatType"),
          _classes: "text-dark font-weight-normal",
        },
        {
          key: "product",
          _style: "width:10%",
          label: this.$i18n.t("itemCount"),
          _classes: "text-dark font-weight-normal",
        },
        {
          key: "action",
          label: "",
          _style: "width:5%",
          _classes: "text-right text-dark font-weight-normal",
        },
      ];
    },
    // countMember(){
    //   return this.data.length
    // },
    items() {
      const data = this.data || [];
      let detail = [];

      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        let name = item.name || "-";
        let taxId = item.taxId || "-";
        let supplierCode = item.supplierCode || "-";
        let address = item.address || "-";
        let contactName = item.contactName || "-";
        let phone = item.phone || "-";
        let email = item.email || "-";
        let vatPercentage = item.vatPercentage || 0;
        let creditTerm = item.creditTerm || 0;
        let product = item.product || 0;
        let vatOption = "-";
        if (item.vatOption === "None VAT") {
          vatOption = this.$t('noneVat');
        } else if (item.vatOption === "Including VAT") {
          vatOption = this.$t('incVat');
        } else if (item.vatOption === "Excluding VAT") {
          vatOption = this.$t('excVat');
        }
        detail.push({
          index: i + 1,
          id: item.id,
          objectId: item.objectId,
          name: name,
          taxId: taxId,
          supplierCode: supplierCode,
          address: address,
          contactName: contactName,
          phone: phone,
          email: email,
          vatOption: vatOption,
          vatPercentage: vatPercentage,
          creditTerm: creditTerm,
          product: product,
        });
      }
      return detail;
    },
  },
  created() {
    this.getSupplierReport();
  },
  methods: {
    ...util,
    toggleDetails(item) {
      this.$router.push('/supplier/detail/' + item.objectId)
    },
    getSupplierReport(page = 1) {
      this.loadingButton = false;
      this.loading = true;
      const uid = this.uid;
      const params = {
        searchAttr: this.search,
        page: page,
        limit: 50,
      };
      const headers = { shopObjectId: this.shopObjectId };

      local({
        url: "/api/v3.0/supplier",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.data = res.data.data;
          if (res.data.paginate.items == undefined) {
            this.meta_data.items = 0;
          } else {
            this.meta_data.items = res.data.paginate.items;
          }
          this.meta_data.last_page = res.data.paginate.pageCount;
          this.meta_data.current_page = res.data.paginate.currentPage;
          this.meta_data.itemCount = res.data.paginate.itemCount;
          this.meta_data.limit = res.data.paginate.perPage;
          this.countMember = res.data.paginate.items;
          this.loading = false;
          this.loadingButton = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // exportMemberReport() {
    //   this.loadingButton = false;
    //   const uid = this.uid;
    //   const params = {
    //     search: this.search,
    //   };
    //   const headers = { shopObjectId: this.shopObjectId };

    //   report({
    //     url: "/shop/v1.0/getcustomer/" + uid + "/excel",
    //     params: params,
    //     method: "GET",
    //     headers: headers,
    //     responseType: "blob", // important
    //   })
    //     .then((response) => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "ข้อมูลสมาชิก.xlsx"); //or any other extension
    //       document.body.appendChild(link);
    //       link.click();
    //       this.loadingButton = true;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    // exportMemberPdf(memberObjectId) {
    //   const uid = this.uid;
    //   const params = {
    //     shopObjectId: this.shopObjectId,
    //     memberObjectId: memberObjectId,
    //   };
    //   const headers = { shopObjectId: this.shopObjectId };

    //   report({
    //     method: "get",
    //     url: "/print/v1.0/" + uid + "/packagelabel/a4",
    //     params: params,
    //     headers: headers,
    //     responseType: "arraybuffer",
    //   })
    //     .then((response) => {
    //       let blob = new Blob([response.data], { type: "application/pdf" }),
    //         url = window.URL.createObjectURL(blob);
    //       window.open(url);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
  },
};
</script>
<style>
.address-cell {
  max-width: 500px; /* กำหนดความกว้างสูงสุดของคอลัมน์ */
  white-space: normal; /* อนุญาตให้ขึ้นบรรทัดใหม่ */
  word-wrap: break-word; /* ตัดคำเมื่อเกินขอบเขต */
  overflow-wrap: break-word; /* ตัดคำเมื่อเกินขอบเขต (รองรับเบราว์เซอร์อื่น) */
}
</style>
